export const BooleanFieldLabels = {
  true: 'Yes',
  false: 'No',
};
